export default class Giftcertificate {
  constructor() {
    this.elToggle = document.querySelector('#toggle-validate-giftcard')
    this.el = document.querySelector('#validate-giftcard')
    this.show = false

    this.init = this.init.bind(this)
    this.toggleShow = this.toggleShow.bind(this)
    this.previewShow = this.previewShow();
    this.init()
  }

  init() {
      if (!this.el) return false
      if (!this.elToggle) return false
    this.elToggle.addEventListener('click', ev => this.toggleShow(ev))
  }

    toggleShow(ev) {
    ev.preventDefault()
    this.show = !this.show
    if (this.show)
      this.el.style.cssText = 'display: block;'
    else this.el.style.cssText = 'display: none;'
  }

    previewShow() {
      if (!$("#giftcertificateModal").hasClass("jsPopulate")) {
         
          $("#giftcertificateModal").modal('show');
      }
      
  }
}